var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.165,
    height: 33.739,
    viewBox: "0 0 33.165 33.739",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffd112"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.424,
    stopColor: "#f0c307"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e7ba00"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_086---Desktop-Calendar",
    "data-name": "086---Desktop-Calendar",
    transform: "translate(0 -0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M51,38.161h2.8a1.2,1.2,0,0,0,1.193-1.368L51.572,13Z",
    transform: "translate(-21.837 -6.137)",
    fill: "#ffd10a"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-path",
    width: 29.735,
    height: 30.879,
    rx: 3,
    transform: "translate(0 2.86)",
    fill: "#eec106"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    "data-name": "Shape",
    d: "M29.161,11.144v3.431H4V11.144A1.147,1.147,0,0,1,5.144,10H28.017A1.147,1.147,0,0,1,29.161,11.144Z",
    transform: "translate(-1.713 -4.853)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    "data-name": "Shape",
    d: "M29.161,18V35.252a1.147,1.147,0,0,1-.337.812L25.5,39.392a1.147,1.147,0,0,1-.812.337H5.144A1.147,1.147,0,0,1,4,38.586V18Z",
    transform: "translate(-1.713 -8.278)",
    fill: "#ecf0f1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    "data-name": "Shape",
    d: "M15.431,36.437a3.434,3.434,0,0,0,3.431-3.431V28.431a3.431,3.431,0,1,0-6.862,0v4.575A3.434,3.434,0,0,0,15.431,36.437Zm-2.287-8.006a2.287,2.287,0,1,1,4.575,0v4.575a2.287,2.287,0,0,1-4.575,0Z",
    transform: "translate(-5.138 -11.275)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    "data-name": "Shape",
    d: "M28.572,35.293a.572.572,0,1,0,0,1.144h4.575a.572.572,0,0,0,0-1.144H31.431V25.572a.572.572,0,0,0-.976-.4l-2.287,2.287a.572.572,0,0,0,.809.809l1.311-1.311v8.341Z",
    transform: "translate(-11.989 -11.275)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-6",
    "data-name": "Shape",
    d: "M26.724,48H13.572a.572.572,0,1,0,0,1.144H26.724a.572.572,0,1,0,0-1.144Z",
    transform: "translate(-5.566 -21.123)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-7",
    "data-name": "Shape",
    d: "M44.9,49a1.153,1.153,0,0,1-.234.337l-3.328,3.328A1.154,1.154,0,0,1,41,52.9V50.144A1.147,1.147,0,0,1,42.144,49Z",
    transform: "translate(-17.555 -21.551)",
    fill: "#d1d4d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_3882",
    "data-name": "Group 3882",
    transform: "translate(5.718)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape-8",
    "data-name": "Shape",
    d: "M17.811,3.859h-1.2a2.859,2.859,0,1,0-2.613,4,.572.572,0,1,1,0,1.144A4,4,0,1,1,17.776,3.67a.525.525,0,0,1,.034.189Z",
    transform: "translate(-9.999 -0.999)",
    fill: "#176eb5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-9",
    "data-name": "Shape",
    d: "M36.811,3.859h-1.2a2.859,2.859,0,1,0-2.613,4,.572.572,0,1,1,0,1.144A4,4,0,1,1,36.776,3.67a.526.526,0,0,1,.034.189Z",
    transform: "translate(-18.134 -0.999)",
    fill: "#176eb5"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.278ae406ba295a7b383cdf257395c278.svg";
export { ForwardRef as ReactComponent };